import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";
const selectDomain = (state) => state.filter || initialState;

export const selectClients = createSelector([selectDomain], (state) => {
  const filter = state.clients?.map((entity) => ({
    label: entity.companyName,
    value: entity._id,
  }));

  const sortedFilter = filter?.sort((a, b) =>
    a.label.trim().toLowerCase().localeCompare(b.label.trim().toLowerCase())
  );

  return sortedFilter || [];
});

export const selectProjects = createSelector([selectDomain], (state) => {
  const filter = state.projects?.map((entity) => ({
    label: entity.projectCode,
    value: entity._id,
  }));

  const sortedFilter = filter?.sort((a, b) =>
    a.label.trim().toLowerCase().localeCompare(b.label.trim().toLowerCase())
  );

  return sortedFilter || [];
});

export const selectLabs = createSelector([selectDomain], (state) => {
  const filter = (state.labs || []).map((entity) => ({
    label: entity.name,
    value: entity._id,
  }));

  const sortedFilter = filter.sort((a, b) =>
    a.label.trim().toLowerCase().localeCompare(b.label.trim().toLowerCase())
  );

  return sortedFilter;
});
